import React, { useState } from "react";
import "./ResetPassword.css";
import Qcr from "../../images/qcr.png";
import Container from "react-bootstrap/Container";
import { Row, Col, Button, Form, Toast } from "react-bootstrap";
import { ResetPasswordAPI } from "../../apis/LoginAPI";
import md5 from "md5";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function ResetPassword() {
  const [newpassword, setNewPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");
  const [showResetPassSuccess, setResetPassSuccess] = useState(false);
  const [showInvalidPass, setInvalidPass] = useState(false);
  const [showResetPassNotMatch, setResetPassNotMatch] = useState(false);
  const [showCurrentPass, setCurrentPass] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isDisabled, setIsDisabled] = useState(true);
  const [validated, setValidated] = useState(false);

  const token = searchParams.get("token");

  const handleNewPassword = (e) => {
    var pass = e.target.value;
    setNewPassword(pass);
    if (
      pass != null &&
      pass.trim() != "" &&
      confirmpassword != null &&
      confirmpassword.trim() != "" &&
      pass === confirmpassword
    )
      setIsDisabled(false);
    else setIsDisabled(true);
  };
  const handleConfirmPassword = (e) => {
    var cpass = e.target.value;
    setConfirmPassword(cpass);
    if (
      newpassword != null &&
      newpassword.trim() != "" &&
      cpass != null &&
      cpass.trim() != "" &&
      newpassword === cpass
    )
      setIsDisabled(false);
    else setIsDisabled(true);
  };
  const handleResetPassword = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (
      form.checkValidity() === false ||
      newpassword === "" ||
      confirmpassword === null
    ) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      setValidated(true);
      if (newpassword === confirmpassword) {
        var resetpassword = md5(newpassword);

        var result = await ResetPasswordAPI({
          newpassword: resetpassword.toUpperCase(),
          token: token,
        });

        if (result.status === 200) {
          setResetPassSuccess(true);
          setIsDisabled((current) => !current);
          navigate("/");
        } else if (result.status === 201) setInvalidPass(true);
        else if(result.status === 202) setCurrentPass(true);
      } else {
        setResetPassNotMatch(true);
      }
    }
    if (e.key === "Enter") {
      e.preventDefault();
      handleResetPassword();
    }
  };
  //

  return (
    <>
      <Container fluid>
        <Row>
          <Col className="p-0">
            <div className="login-wrapper">
              <Container fluid>
                <div className="login-wrapper-inner">
                  <div className="login-form">
                    <div href="#" className="qcryearslogo">
                      <img src={Qcr} alt="QCR" width={149} />
                    </div>
                    <h1>Reset Password</h1>
                    <Form
                      className="login-box"
                      noValidate
                      validated={validated}
                      onSubmit={handleResetPassword}
                    >
                      <Form.Group className="mb-3" controlId="formBasicName">
                        <Form.Control
                          type="password"
                          placeholder="New Password"
                          onChange={handleNewPassword}
                          required
                        />
                      </Form.Group>
                      <Form.Group
                        className="mb-3"
                        controlId="formBasicPassword"
                      >
                        <Form.Control
                          type="password"
                          placeholder="Confirm Password"
                          onChange={handleConfirmPassword}
                          required
                        />
                      </Form.Group>
                      <Button
                        className={
                          isDisabled ? "login-button disabled" : "login-button"
                        }
                        variant="primary"
                        type="submit"
                        onClick={handleResetPassword}
                      >
                        Submit
                      </Button>
                    </Form>
                  </div>
                </div>
              </Container>
            </div>
          </Col>
        </Row>
      </Container>
      {/* Successfully Reset Password */}
      <Toast
        className="wrong-otp-toast"
        position="top-end"
        show={showResetPassSuccess}
        onClose={() => setResetPassSuccess(false)}
        delay={3000}
        autohide
      >
        <Toast.Body>
          <h3>Success</h3>
          <p>Your Password is Successfully Updated!</p>
        </Toast.Body>
      </Toast>
      {/* Successfully Reset Password */}
      <Toast
        className="wrong-otp-toast"
        position="top-end"
        show={showResetPassNotMatch}
        onClose={() => setResetPassNotMatch(false)}
        delay={3000}
        autohide
      >
        <Toast.Body>
          <h3>Error</h3>
          <p>Password Did Not Match!</p>
        </Toast.Body>
      </Toast>
      {/* Invalid  */}
      <Toast
        className="wrong-otp-toast"
        position="top-end"
        show={showInvalidPass}
        onClose={() => setInvalidPass(false)}
        delay={3000}
        autohide
      >
        <Toast.Body>
          <h3>Error</h3>
          <p>Token expired/Invalid token</p>
        </Toast.Body>
      </Toast>
      <Toast
        className="wrong-otp-toast"
        position="top-end"
        show={showCurrentPass}
        onClose={() => setCurrentPass(false)}
        delay={3000}
        autohide
      >
        <Toast.Body>
          <h3>Error</h3>
          <p>New password must not be the current password.</p>
        </Toast.Body>
      </Toast>
    </>
  );
}
